<div>
<a href="https://4k-analytics.de" target="_blank" rel="noopener noreferrer" class="logo">
	Generische Gesundheitsplattform
</a>
<br/>
<p class="mb-0">
	Version {{versions.version}}
</p>
</div>
<app-privacy-toggle-big-button></app-privacy-toggle-big-button>